import { css } from 'styled-components'
import { themeColor } from 'Pages/leadNeo/style'
import { themeFontFamily, themeFontWeight } from 'LibNeo'

export const tooltipStyles = css`
	.ant-tooltip-inner {
		max-width: 280px;
		padding: 12px;
		white-space: pre-wrap;
		background-color: ${themeColor('extraBackground3')};
		box-shadow: 0 8px 16px rgba(39, 40, 51, 0.16);
		border-radius: 6px;
		font-family: ${themeFontFamily('SBSansText')};
		color: ${themeColor('white')};
		font-size: 12px;
		font-weight: ${themeFontWeight('SBSansText', 'regular')};
		line-height: 16px;
	}

	.ant-tooltip-arrow {
		box-shadow: none;
		&::before {
			background-color: ${themeColor('extraBackground3')};
		}
	}
`
